module.exports = __webpack_public_path__ + "img/uos.5a06c64a.svg";